import OnlineServices from './OnlineServices';
import './onlineServices.scss';
declare function Translate(key: string): string;

const OnlineServicesLarge = () => {
    return (
        <div className='onlineServices'>
            <div className='onlineServicesLargeTitle'>להזדהות מול אתרים נוספים עם חשבון אחד</div>
            <div className='onlineServiceLinks'>
                
                <div className='myGovImage largeIcon' />
                <div className='netamishpatImage largeIcon' />
                <div className='ashraiImage largeIcon' />
                <div className='bituachImage largeIcon' />
                <div className='yerushalmiImage largeIcon' />
            </div>
        </div>
    );
}

export default OnlineServicesLarge;